import { FileDownloadOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'

import CustomDialog from '~/components/customDialog'
import { TAsyncExportJob } from '~/features/exports/models'
import rem from '~/utils/ui'

type TProps = {
  job: TAsyncExportJob | null
  isOpen: boolean
  isDownloading: boolean
  onClose: () => void
  onDismiss: () => void
  onDownload: () => void
}

function formatRowCounts(meta: TAsyncExportJob['meta']): string | null {
  const counts = meta?.rowCounts
  if (!counts || Object.keys(counts).length === 0) {
    return null
  }
  return Object.entries(counts)
    .map(([key, value]) => `${key}: ${value}`)
    .join(' · ')
}

function AsyncExportReadyDialog({
  job,
  isOpen,
  isDownloading,
  onClose,
  onDismiss,
  onDownload,
}: TProps) {
  const rowCountsText = job ? formatRowCounts(job.meta) : null

  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onDismiss}
      title="Your export is ready"
      cancelText="Not now"
      confirmText="Download"
      onConfirm={onDownload}
      isDisabled={isDownloading}
      confirmButtonTestId="async-export-ready-download"
      cancelButtonTestId="async-export-ready-dismiss"
    >
      <Stack spacing={1.5}>
        <Typography sx={{ fontSize: rem(14), color: 'text.secondary' }}>
          {job?.label ?? 'Your export'} is ready to download.
        </Typography>
        {rowCountsText ? (
          <Typography sx={{ fontSize: rem(13), color: 'text.secondary' }}>
            {rowCountsText}
          </Typography>
        ) : null}
        <Stack direction="row" alignItems="center" spacing={1}>
          <FileDownloadOutlined sx={{ fontSize: rem(18), color: 'mainFont' }} />
          <Typography sx={{ fontSize: rem(13) }}>
            {job?.downloadFilename ?? 'Export file'}
          </Typography>
        </Stack>
      </Stack>
    </CustomDialog>
  )
}

export default AsyncExportReadyDialog
